import Preview from './Preview'
import Details from './Details'
export default {
  Preview
  // Details
}
